import { render } from "./cost-summary.vue?vue&type=template&id=5c92949e"
import script from "./cost-summary.vue?vue&type=script&lang=js"
export * from "./cost-summary.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__